/* eslint-disable no-prototype-builtins,no-undef */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// noinspection JSUnresolvedVariable
// @ts-ignore
function validParams(paramsJson) {
    // @ts-ignore
    if (paramsJson.appId === null || paramsJson.appId === '' || paramsJson.appId === undefined) {
        return 'appId';
    }
    // @ts-ignore
    if (paramsJson.tokenData === null || paramsJson.tokenData === '' || paramsJson.tokenData === undefined) {
        return 'tokenData';
    }
    // @ts-ignore
    if (paramsJson.orderId === null || paramsJson.orderId === '' || paramsJson.orderId === undefined) {
        return 'orderId';
    }
    // @ts-ignore
    if (paramsJson.orderAmount === null || paramsJson.orderAmount === '' || paramsJson.orderAmount === undefined) {
        return 'orderAmount';
    }
    // @ts-ignore
    if (paramsJson.customerName === null || paramsJson.customerName === '' || paramsJson.customerName === undefined) {
        return 'customerName';
    }
    // @ts-ignore
    if (paramsJson.customerPhone === null || paramsJson.customerPhone === '' || paramsJson.customerPhone === undefined) {
        return 'customerPhone';
    }
    // @ts-ignore
    if (paramsJson.customerEmail === null || paramsJson.customerEmail === '' || paramsJson.customerEmail === undefined) {
        return 'customerEmail';
    }
    // @ts-ignore
    if (paramsJson.stage === null || paramsJson.stage === '' || paramsJson.stage === undefined) {
        return 'stage';
    }
    // @ts-ignore
    paramsJson['source'] = 'capacitor-hyb';
    return null;
}
class Webform {
    // @ts-ignore
    async startPaymentWEB(params) {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        return new Promise((resolve, reject) => {
            const my_form = document.createElement('FORM');
            my_form.id = 'redirectForm';
            // @ts-ignore
            my_form.method = 'POST';
            // @ts-ignore
            my_form.target = 'POPUPW';
            const paramsJson = params;
            const errorString = validParams(paramsJson);
            if (errorString !== null) {
                return resolve({
                    type: 'CashFreeResponse',
                    txStatus: 'FAILED',
                    txMsg: errorString + ' not provided',
                    // @ts-ignore
                    orderId: paramsJson.orderId,
                });
            }
            let URL;
            // @ts-ignore
            if (paramsJson.stage.toUpperCase() === 'TEST') {
                URL = 'https://test.cashfree.com/billpay/checkout/post/submit';
            }
            else {
                URL = 'https://www.cashfree.com/checkout/post/submit';
            }
            // @ts-ignore
            my_form.action = URL;
            Object.keys(paramsJson).forEach(key => {
                const my_tb = document.createElement('INPUT');
                // @ts-ignore
                my_tb.type = 'HIDDEN';
                // @ts-ignore
                my_tb.name = key;
                // @ts-ignore
                my_tb.value = paramsJson[key];
                my_form.appendChild(my_tb);
            });
            document.body.appendChild(my_form);
            const paymentWindow = window.open('about:blank', 'POPUPW');
            // @ts-ignore
            paymentWindow.focus();
            const timer = setInterval(checkChild, 500);
            function checkChild() {
                // @ts-ignore
                if (paymentWindow.closed) {
                    clearInterval(timer);
                    return resolve({
                        type: 'CashFreeResponse',
                        txStatus: 'CANCELLED',
                        txMsg: 'transaction cancelled by the user',
                        // @ts-ignore
                        orderId: paramsJson.orderId,
                    });
                }
            }
            window.onmessage = (event) => {
                const response = event.data;
                const responseJson = JSON.parse(response);
                clearInterval(timer);
                // @ts-ignore
                paymentWindow.close();
                return resolve(responseJson);
            };
            // @ts-ignore
            my_form.submit();
        });
    }
}
const WEBFORM = new Webform();
export { WEBFORM, };
//# sourceMappingURL=webform.js.map